import ClearingAPI from '@shared/api';

export const {
    userManagement: {
        get: getMethods,
        addUser: addUsers,
        putUser: putUsers,
        getbyFdid: getbyFdid,
        deleteUser: deleteUser,
        uploadFile: uploadFile,
        assignSubAccounts: assignSubAccounts,
    },
} = ClearingAPI.settings;
